<script lang="ts">
  import {
    initPageFromUrl,
    loadPageStateFromCookie,
    onClickAnchor,
    onWindowPopState,
    pushPage,
  } from "state/page";
  import { onDestroy, onMount } from "svelte";
  import { urlToPage } from "../../state/url-mappers";
  import { whoami } from "../../services/api";
  import { Mimir } from "bildebanken-model";
  import { getRelease } from "../../config";
  import { getInitialViewSpecified, getResetView } from "../../services/plugin-customization";
  import { isPlugin } from "state/app";

  initPageFromUrl();

  let rootElement: HTMLElement | null | undefined;

  onMount(async () => {
    rootElement = document.getElementById("bildebanken-root");
    rootElement?.addEventListener("click", onClickAnchor);

    // This mainly has the function of transforming unknown URL paths to "/images".
    // We wait until here to avoid conflicts with login redirects.

    const page = urlToPage(window.location.href);

    const resetView = getResetView();
    const initialViewSpecified = getInitialViewSpecified();

    if (page.type === "LANDING_PAGE" && isPlugin && !resetView && !initialViewSpecified) {
      await loadPageStateFromCookie();
    } else {
      pushPage(page);
    }
  });

  if (getRelease() !== "dev") {
    import("@sentry/svelte").then((Sentry) => {
      const user = whoami().then((user: Mimir.User) => {
        Sentry.setUser({
          id: user.id,
          name: user.givenName + user.familyName,
          email: user.email,
        } as { id: string; name: string; email: string });
      });
    });
  }

  onDestroy(() => {
    rootElement?.removeEventListener("click", onClickAnchor);
  });
</script>

<svelte:window on:popstate={onWindowPopState} />
<slot />
